import { v4 as uuidv4 } from 'uuid';

export function RichText(props = {}) {
	return {
		componentName: 'RichText',
		componentId: uuidv4(),
		props: Object.assign(
			{
				textAlignment: 'LEFT',
				textPosition: 'LEFT',
				text: '',
			},
			props,
		),
	};
}
